import { StarFilled } from '@ant-design/icons';
import { Person } from 'assets';
import Image from 'next/image';
import React, { FC } from 'react';
import { twMerge } from 'tailwind-merge';

interface Props {
  className?: string;
  name?: string;
  description?: string;
}

const Card: FC<Props> = ({ className, name, description }) => {
  return (
    <div
      className={twMerge(
        `rounded-3xl bg-dropDownMenuBg p-6 flex flex-col gap-4`,
        className,
      )}
    >
      <div className='flex gap-5 items-center'>
        <Image src={Person} alt='Person' width={56} height={56} />
        <div className='flex flex-col gap-2'>
          <p>{name}</p>
          <div className='flex items-center gap-1'>
            <StarFilled className='w-5 h-5 text-white/80' />
            <StarFilled className='w-5 h-5 text-white/80' />
            <StarFilled className='w-5 h-5 text-white/80' />
            <StarFilled className='w-5 h-5 text-white/80' />
            <StarFilled className='w-5 h-5 text-white/80' />
          </div>
        </div>
      </div>
      <p className='text-grayZl-600 text-base font-normal'>{description}</p>
    </div>
  );
};

export default Card;
